class ModalService {
  constructor() {
    this.modals = {};
  }

  register(id, actions) {
    this.modals[id] = actions;
  }

  unregister(id) {
    delete this.modals[id];
  }

  show(id) {
    this.modals[id]?.show();
  }

  hide(id) {
    this.modals[id]?.hide();
  }
}

export const modalService = new ModalService();
